export const BASE_URL = {
  REST: "https://pokeapi.co/api/v2",
  /** Root of the sprite repository the API's own sprite URLs point at. */
  SPRITES: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites",
} as const;
